
import categories from "./categories";

export default function renderVehicleTitle(vehicle?: any) {
  if (vehicle) {
    let pageTitle = `${vehicle.make} ${vehicle.model} ${vehicle.trim_level}`;
      
    if (vehicle.fuel_type === "BEV") {
      const body_type = vehicle.body_type.toLowerCase();
  
      if (body_type === "chassis cab" || body_type === "panel van" || body_type === "car van") {
        pageTitle += " - " + categories.electricVans
      }
      else {
        pageTitle += " - " + categories.electricCars
      }
      
    }
    else if (vehicle.fuel_type === "PHEV") {
      pageTitle += " - " + categories.pluginHybrids
    }
  
    return pageTitle;
  }

  return "Vehicle"
}